import { baseInstance } from '@/apis';

const { post: basePost } = baseInstance;

// 文章相关接口
// 获取文章分类列表接口
export const getArticleCategoryList = (params) => {
  return basePost('/laoa-admin/pc/article-cate/page', params);
};

// 获取文章详情接口
export const getArticleCategoryDetail = (params) => {
  return basePost('/laoa-admin/pc/article-cate/detail', params);
};

// 获取文章列表接口
export const getArticleList = (params) => {
  return basePost('/laoa-admin/pc/article/page', params);
};

// 获取文章详情接口
export const getArticleDetail = (params) => {
  return basePost('/laoa-admin/pc/article/detail', params);
};

// 网站基础信息接口
// 获取网站基础详情接口
export const getSiteConfigDetail = (params) => {
  return basePost('/laoa-admin/pc/admin/site-config/detail', params);
};
